import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import { renderMailReplaceKeys } from 'helpers/mail';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormLangRichEditor from 'components/forms/FormLangRichEditor';

import EmailPreview from 'components/layout/EmailPreview';

class WhiteLabelSystemMailData extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.defaultFieldTree = ['systemMails', props.dataIndex];
  }

  componentDidUpdate = prevProps => {
    const { dataIndex } = this.props;

    if (prevProps.dataIndex !== dataIndex) {
      this.defaultFieldTree = ['systemMails', dataIndex];
    }
  };

  render() {
    const {
      intl: { messages },
      disabled,
      systemMail,
      data,
      colSpan,
      project,
    } = this.props;

    return (
      <tr class="row-details">
        <td colSpan={colSpan}>
          <Row>
            <Col xs={12} md={5}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <div class="form-group-attached">
                    <FormLangRichEditor
                      id={data.getId()}
                      name="content"
                      label={messages.content}
                      value={data.getContent()}
                      meta={data.getContentMetaInformation()}
                      validation={data.getContentValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                  </div>

                  {!!systemMail.possibleSubstitutes.length && (
                    <div class="m-t-15">
                      <dl class="dl-horizontal no-margin">
                        <p>{messages.use_following_list_to_personalize_your_emails}</p>
                        {renderMailReplaceKeys(messages, systemMail.possibleSubstitutes)}
                      </dl>
                    </div>
                  )}
                </div>
              </div>
            </Col>

            <Col xsHidden smHidden md={7}>
              <p>{messages.preview}</p>
              <EmailPreview systemMail={systemMail} content={data.getContent()} projectConfig={project} />
            </Col>
          </Row>
        </td>
      </tr>
    );
  }
}

export default injectIntl(WhiteLabelSystemMailData);
